import { useState } from "react";

export function useThematicMap() {
  const [open, setOpen] = useState(false);
  const [attribute, setAttribute] = useState<string | null>(null);

  function toggle() {
    setOpen((o) => !o);
  }

  function close() {
    setOpen(false);
  }

  return { open, attribute, setAttribute, toggle, close };
}
